import
  React, {
  useContext,
  useEffect
}  from 'react';

import
  PropTypes
from 'prop-types';

import {
  Base,
  Carousel,
  HContainer,
  Image,
  JourneyProvider,
  Spinner,
  Text,
  VContainer,
  VFillContainer
} from '@vodacom/web-common';

import {
  CacheKeys,
  CustomColors,
  Icons
} from '../../../constants';

import {
  Just4You,
  NoOffers
} from '.';

import {
  PrimaryButton
} from 'components';

import {
  formatCurrency,
  getStorageWithExpiry,
  isEqual,
  isFeatureEnabled
} from 'helpers';

import {
  BundleProvider
} from '../providers';

import {
  FeatureToggles
} from '../../../constants';

import {
  AppContext
} from 'context';

export const CheaperBundles = props => {

  const { config } = useContext(AppContext);

  const [
    state,
    setState
  ] = React.useState({
    canUseLocation: JourneyProvider.get('Common', 'canUseLocation'),
    offers: getStorageWithExpiry('offers', 'offers', null),
    showJ4uModal: false,
    selectedOffer: null,
    userType: getStorageWithExpiry('msisdn', 'msisdnType', 'PREPAID'),
    showBundlesRefresh: JourneyProvider.get('Common', 'showBundlesRefresh', false),
    loading: true,
    error: false
  });

  useEffect(() => {

    const init = async () => {

      if (isEqual(state?.userType, 'CONTRACT')) {

        setState(prevState => ({
          ...prevState,
          error: true,
          loading: false,
          offers: null
        }));

        return;
      }

      await getOffers();
    };

    init();
  }, []);

  const refreshOffers = async () => {

    const response = await BundleProvider.getOffers();

    if (!response.ok) {

      setState(prevState => ({
        ...prevState,
        loading: false,
        error: response?.error
      }));

      return;
    }

    setState(prevState => ({
      ...prevState,
      loading: false,
      offers: response?.result?.vasList
    }));
  };

  const getOffers = async () => {

    const offers = await BundleProvider.getCachedItem(
      CacheKeys.Offers,
      null
    );

    if (offers !== null && offers !== 'No offers') {

      JourneyProvider.set('Common', { showBundlesRefresh: true });

      setState(prevState => ({
        ...prevState,
        loading: false,
        error: null,
        offers: offers?.result?.vasList,
        showBundlesRefresh: true
      }));

      return;
    }

    if (isEqual(offers, 'No offers')) {

      JourneyProvider.set('Common', { showBundlesRefresh: true });

      setState(prevState => ({
        ...prevState,
        loading: false,
        error: 'error',
        offers: [ 'No offers' ],
        showBundlesRefresh: true
      }));

      return;
    }

    if (offers === null && state?.showBundlesRefresh) {

      setState(prevState => ({
        ...prevState,
        loading: false,
        error: null,
        offers: []
      }));

      return;
    }

    refreshOffers();
  };

  const buildOffers = () => {

    const offersComponentList = [];

    state.offers.forEach((offer, index) => {

      const onOfferClick = () => {

        if (!getStorageWithExpiry('offers', 'offers', null)) {

          JourneyProvider.set('Common', { showBundlesRefresh: true });

          setState(prevState => ({
            ...prevState,
            offers: null,
            showBundlesRefresh: true
          }));

          return;
        }

        setState(prevState => ({
          ...prevState,
          showJ4uModal: true,
          selectedOffer: offer
        }));
      };

      offersComponentList.push(
        <VFillContainer
          width={'100%'}
          key={`offer--${index}`}
          justifyContent={'flex-start'}
          padding={'0 16px'}
          onClick={onOfferClick}>

          <HContainer
            alignItems={'center'}
            justifyContent={'flex-start'}
            padding={'14px 32px 14px 10px'}
            boxShadow={`0px 5px 7px 0px ${CustomColors.TransparentBlack1}`}
            borderRadius={'4px'}>

            <Base
              display={'flex'}
              margin={'0 8px 0 0'} >

              <Image
                width={'40px'}
                height={'40px'}
                src={Icons.UpdownArrows} />
            </Base>

            {
              buildOfferText(
                offer?.description,
                offer?.price
              )
            }

          </HContainer>
        </VFillContainer>
      );
    });

    return (
      <Carousel
        componentList={offersComponentList}
        autoSwipeTime={props.autoSwipeTime}
        navigationGridMargin={'0 6px 12px'} />
    );
  };

  const buildOfferText = (
    description,
    price
  ) => {

    const offerText = `${description} at ${formatCurrency(price)}`;

    return (

      <Text
        fontSize={'14px'}
        display={'flex'}
        textAlign={'center'}
        whiteSpace={'pre-wrap'}>

        {offerText}
      </Text>
    );
  };

  const buildLoader = () => {

    return (

      <Base
        display={'flex'}
        justifyContent={'center'}
        margin='20px auto'>

        <Spinner
          margin={'0 auto'}
          color={CustomColors.Red1}
          size='50' />
      </Base>
    );
  };

  const buildRefresh = () => {

    return (

        <VContainer
          padding={'20px'}
          boxShadow={`0px 5px 15px 0px ${CustomColors.TransparentBlack1}`}
          borderRadius={'4px'}>

          <Text
            fontSize={'14px'}
            color={CustomColors.Grey9}
            textAlign={'center'}>

            {'Your current offers have expired. Please refresh to see the latest offers.'}
          </Text>

        <PrimaryButton
          margin={'16px 0 0'}
          text={'Refresh'}
          maxWidth={'100%'}
          onClick={() => {

            setState(prevState => ({
              ...prevState,
              loading: true
            }));

            refreshOffers();
          }}/>

        </VContainer>
    );
  };

  return (
    <>

      { state.showJ4uModal &&

        <Just4You
          offer={state.selectedOffer}
          refreshOffers={refreshOffers}
          onClose={() => {

            setState(prevState => ({
              ...prevState,
              showJ4uModal: false
            }));
          }}/>
      }

      <VContainer>

        <Text
          fontSize={'16px'}
          padding={'16px'}
          fontWeight={'bold'}>
          {'Cheaper bundle offers for you'}

        </Text>
      </VContainer>
      {
        !isFeatureEnabled(config, FeatureToggles.EnableJ4UTown)

          ? <NoOffers/>

          : state.error

            ? <NoOffers/>

            : state.loading

              ? buildLoader()

              : state.offers?.length > 0

                ? buildOffers()

                : buildRefresh()
      }
    </>
  );
};

CheaperBundles.propTypes = {
  noOffersAvailable: PropTypes.bool,
  autoSwipeTime: PropTypes.number
};

CheaperBundles.defaultProps = {
  noOffersAvailable: true,
  autoSwipeTime: 6000
};
